import { useState } from "react";
import "@/index.css";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Steps } from "./components/Steps";
import { Footer } from "./components/Footer";
import { FloatingWhatsApp } from "./components/FloatingWhatsApp";
import { translations } from "./lib/i18n";

function App() {
  const [lang, setLang] = useState("en");
  const t = translations[lang];

  return (
    <div className="App bg-[#050505] text-white min-h-screen font-sans">
      <Navbar lang={lang} setLang={setLang} t={t} />
      <main>
        <Hero t={t} lang={lang} />
        <About t={t} />
        <Services t={t} lang={lang} />
        <Steps t={t} lang={lang} />
      </main>
      <Footer t={t} lang={lang} />
      <FloatingWhatsApp lang={lang} />
    </div>
  );
}

export default App;
